import { AuthContextProps } from "react-oidc-context";
import store from "..";
import { authProvider } from "../components/authProvider";
import { getCurrentClient, getPlantReferences } from "../configuration";
import { SCENARIO_STATUS } from "../interfaces/IScenario";
import {
  REACT_APP_APIM_URL_COMPUTE,
  REACT_APP_APIM_URL_METADATA,
  RTA_TIME_FREQ,
  TI_TIME_FREQ,
  USER_ROLES_BLACKLIST,
  USER_ROLES_WHITELIST,
  AUTHENTICATION_TYPE,
  AUTH_TYPE,
  REACT_APP_APIM_URL
} from "./GlobalConstants";
import { IChangeHistoryMinMaxTempLog, IChangeHistoryRuleLog } from "../interfaces/IChangeHistoryLog";

/**
 * Convert string into dateformat
 * @param {string} str
 */
export function convertDateUs(str: Date): string {
  let date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);

  return [mnth, day, date.getFullYear()].join("/");
}

interface iAccessToken {
  accessToken?: string;
  expiresIn?: string;
  homeAccountIdentifier?: string;
  idToken?: string;
}

/**
 * get access token from localstorage
 */
export function getAccessToken(): any {
  let accessToken: iAccessToken = {};

  Object.keys(localStorage).forEach(function (key) {
    let storage: string = localStorage.getItem(key) || "";

    if (storage.indexOf("accessToken") >= 0) {
      accessToken = JSON.parse(storage);
    }
  });

  return accessToken.accessToken;
}

export const getToken = async (auth: AuthContextProps | any) => {

  if(isPingIDAuth()){
    // return auth?.user?.access_token;
    return await getOidcToken(auth)
  }
  else{
    const authState = store.getState().authState;
    if(authState.token === ''){
      return await refreshAccessToken()  
    }
    else{ // every scenario in the fucntion should return a promise 
      return Promise.resolve(authState.token);
    }
  } 

}


 export const getOidcToken = async (oidcAuth:any) => {

    if(!oidcAuth?.user?.expired){
      console.log('existing token : ',await oidcAuth?.user?.access_token,'check every time'); 
      return await oidcAuth?.user?.access_token;
    }else{
      const refreshedToken = await oidcAuth?.signinSilent()
      console.log('refreshedToken : ',refreshedToken,'check every time');
      return refreshedToken?.access_token;
    }

  }

/**
* refresh token and store into redux
*/
export async function refreshAccessToken() {


  const { accessToken, expiresOn } = await authProvider.getAccessToken();
  store.dispatch({ type: "ADD_TOKEN", payload: { value: accessToken } });
  store.dispatch({ type: "ADD_EXPIRATION", payload: { value: expiresOn } });
   
  return accessToken;
}

export function toFixedWithoutRounding(value, n): any {
  const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + n + "})?", "g");
  const a = value.toString().match(reg)[0];
  const dot = a.indexOf(".");

  if (dot === -1) {
    // integer, insert decimal dot and pad up zeros
    return a + "." + "0".repeat(n);
  }
  const b = n - (a.length - dot) + 1;
  return b > 0 ? a + "0".repeat(b) : a;
}

export function getFormattedDateTime(date: Date): string {
  return date.toLocaleDateString('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).replace(/\//g, '-') + " " + date.toLocaleTimeString('en-CA',{ 
    hour: '2-digit',
    minute: '2-digit',
    hour12: false 
  });
}

export async function getWeatherdata(plant_id, token) {
  const weatherData: any[] = [];
  const plantname: String = plant_id;
  const weatherdata = await fetch(
    `${REACT_APP_APIM_URL_METADATA}/weather/` + plantname,
    {
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  )
    .then((res) => res.json())
    .then(
      (data) => {
        weatherData.push(data);
        return weatherData;
      },
      (error) => console.log("error", error)
    );
  return await weatherdata;
}

export async function getNotificationConfiguration(accessToken) {

  const notificationConfig = fetch(`${REACT_APP_APIM_URL}/thermalimage/getNotificationConfiguration`, {
    method: "GET",
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
      "Access-Control-Allow-Origin": "*"
    },
  })
  .then((res) => res.json())
  .then(
    (notificationConfig) => {
      return notificationConfig;
    }
  )
  return await notificationConfig;
}

export async function getChangeHistory(accessToken) {

  const changeHistory = fetch(`${REACT_APP_APIM_URL}/thermalimage/getChangeHistory`, {
    method: "GET",
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
      "Access-Control-Allow-Origin": "*"
    },
  })
  .then((res) => res.json())
  .then(
    (changeHistory) => {
      return changeHistory;
    }
  )
  return await changeHistory;
}

export async function getTMTprofileByRunlength(accessToken,id,isFurnaceId,runLength){

  const tmtProfileByRunLength = fetch(`${REACT_APP_APIM_URL}/thermalimage/getTMTprofileByRunlength/${id}/${isFurnaceId}/${runLength}`, {
    method: "GET",
    headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
        "Access-Control-Allow-Origin": "*"
    },
  })
  .then((res) => res.json())
  .then((resp) => {
    let maxTMT = Math.max.apply(null,
      resp.map(function (o) { return o.tmt_max; }));
    let minTMT = Math.min.apply(null,
      resp.map(function (o) { return o.tmt_min; }));
      let dataPoints: { 'runtime': number | null, 'CUSTOM_OULET': number | null, 'TMT_MAX'?: number |null, 'TMT_MIN'?: number | null, }[] = [];
      if (resp.length > 0) {
        const runlengthsData = resp.map((item) => item.runLength);
        const minRunLength = Math.min(...runlengthsData);
        const maxRunLength = Math.max(...runlengthsData);
        //adding below code to handle the case when runlength is not continuous, add null value where run lenght is missing
        for (let runtime = minRunLength; runtime <= maxRunLength; runtime++) {
          const matchingRunlenght = resp.find((item) => item.runLength === runtime);

          if (matchingRunlenght) {
            // If run length  exists, add it
            dataPoints.push({
              runtime,
              CUSTOM_OULET: Number(maxTMT),
              TMT_MAX: matchingRunlenght.tmt_max,
              TMT_MIN: matchingRunlenght.tmt_min,
            });
          } else {
            // If run lenghth is missing, insert NULL
            dataPoints.push({
              runtime : null,
              CUSTOM_OULET: null,
              TMT_MAX: null,
              TMT_MIN: null,
            });
          }
        }
      }
    return {maxTMT,minTMT,dataPoints};
  });

  return await tmtProfileByRunLength;

}

export function getTMTThreshold(notificationConfiguration,selectedFurnace){
  let selectedFurnaceMode = selectedFurnace?.['furnace_mode_name']
  let tmt_threshold_max = notificationConfiguration[0]['furnace maximum tmt'][selectedFurnaceMode]
  let cg_heat_distribution = notificationConfiguration[0]['CG heat distribution'][selectedFurnaceMode]
  let furnace_heat_distribution = notificationConfiguration[0]['Furnace heat distribution'][selectedFurnaceMode]
  let furnace_mode = selectedFurnace?.['furnace_mode']

  return {tmt_threshold_max,cg_heat_distribution,furnace_heat_distribution,furnace_mode};
}

export function getTotalRunLength(data,totalRunlengthStart,tmtThreshold) {

  let res: { 'runtime': number, 'CUSTOM_OUTLET': number, 'CURRENT_TMT_MAX'?: number,'PRED_TMT_MAX'?: number,'PRED_TWALLOUTER_MAX_OUTLET'?: number, 'TMT_DOT'?: number, 'TMT_MIN'?: number, }[] = [];
  let i = totalRunlengthStart;
  let totalRunlengthDay;
  let count  = 0;
  for(var u = 0; u < data.length;u++)
  {
    let obj = { 'runtime': i, 'CUSTOM_OUTLET' : tmtThreshold}
    if(data[u]["tmt_max"] <= tmtThreshold){
      obj["PRED_TMT_MAX"]= data[u]["tmt_max"];
      obj["CURRENT_TMT_MAX"] = data[u]["tmt_max"];
      res.push(obj)
      i++;
      count++;
    }
    else{
      obj["PRED_TMT_MAX"]= data[u]["tmt_max"];
      obj["CURRENT_TMT_MAX"] = data[u]["tmt_max"];
      //res.push(obj);      
      break;
    }
  }
  totalRunlengthDay = i;
  return { res, totalRunlengthDay };

}

export function isPingIDAuth() {
  // console.log(AUTHENTICATION_TYPE + "  :::: " + AUTHENTICATION_TYPE === AUTH_TYPE.PING_ID)
  return AUTHENTICATION_TYPE === AUTH_TYPE.PING_ID
}

export const checkPortalPermission = (userRoles) =>
  USER_ROLES_WHITELIST.map((val) => userRoles.indexOf(val) >= 0);
export const checkPermission = (userRoles) =>
  USER_ROLES_BLACKLIST.map((val) => userRoles.indexOf(val) >= 0);

export function getSignature(object) {
  const { id, status, error_message, signature, ...rest } = object;
  //delete object.signature
  let newsignature = hashfunc_djb2(JSON.stringify(rest));
  return newsignature;
}

function hashfunc_djb2(seed) {
  let hash = 5831;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash << 5) + hash + seed.charCodeAt(i);
  }
  return (hash & 0xffffffffff).toString(16);
}

export function getFactor(feedName) {
  let factor = 0;
  switch (feedName) {
    case "Ethane":
      factor = 1.8;
      break;
    case "Propane":
      factor = 1.25;
      break;
    case "Butane":
      factor = 1.8;
      break;
    default:
      factor = 1.14;
      break;
  }
  return factor;
}

export function isRTA() {
  return store.getState().features.accessibleFeatures.includes("RTA");
}

export function isThermalImage() {
  return store.getState().features.accessibleFeatures.includes("THERMAL_IMAGE");
}

export function isGrafanaAnalytics() {
  return store.getState().features.accessibleFeatures.includes("GRAFANA_ANALYTICS");
}

export function isShellModel() {
  return store.getState().features.accessibleFeatures.includes("SHELL_MODEL");
}

export function isSulphurContent() {
  return store.getState().features.accessibleFeatures.includes("SULPHUR_CONTENT");
}

export async function getRTALiveData(furnace_num, token) {
  let asset = "";
  let fur_num = furnace_num;
  if (getCurrentClient() === "MOL") {
    asset = `TISZA.OL2.FURNACE${fur_num}`;
  }

  const result = await fetch(
    `${REACT_APP_APIM_URL_COMPUTE}/rta/getLastRecord/${asset}`,
    {
      method: "GET",
      headers: {
        Accept: "*/*",
        Connection: "keep-alive",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "Access-Control-Allow-Origin": "*",
      },
    }
  )
    .then((res) => res.json())
    .then(
      (data) => {
        return data;
      },
      (error) => console.log("error", error)
    );
  return await result;
}
export async function getRTATilldateData(
  furnace_num,
  furnaceTypeId,
  feedTypeId,
  token
) {
  let asset = "";
  let fur_num = furnace_num;
  if (getCurrentClient() === "MOL") {
    asset = `TISZA.OL2.FURNACE${fur_num}`;
  }
  let timeInterval = RTATimeFrequency();
  const result = await fetch(
    `${REACT_APP_APIM_URL_COMPUTE}/rta/initializeRTA/${asset}/${timeInterval}/${furnaceTypeId}/${feedTypeId}`,
    {
      method: "GET",
      headers: {
        Accept: "*/*",
        Connection: "keep-alive",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "Access-Control-Allow-Origin": "*",
      },
    }
  )
    .then((res) => res.json())
    .then(
      (data) => {
        return data;
      },
      (error) => console.log("error", error)
    );
  return await result;
}

// give back time interval frequency. i.e. every 5 min we need to udpate data for RTA.
export function RTATimeFrequency() {
  return Number(RTA_TIME_FREQ);
}

export function TITimeFrequency() {
  return Number(TI_TIME_FREQ);
}
export function isHybrid() {
  return store.getState().features.accessibleFeatures.includes("HYBRID_MODE");
}

export function getHybridFields() {
  return [
    "FLOW_HC",
    "COP",
    "CIT",
    "DILUT",
    "SPEC_TYPE",
    "KEY_COMPONENT",
    "SPEC",
    "P_XOVER",
  ];
}

export function isDCS() {
  return store.getState().features.accessibleFeatures.includes("RTA");
}

export async function getGraphDCSData(key, furnace_num, token) {
  const result = await fetch(
    `${REACT_APP_APIM_URL_COMPUTE}/rta/getGraphDCSData/${key}/${furnace_num}`,
    {
      method: "GET",
      headers: {
        Accept: "*/*",
        Connection: "keep-alive",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "Access-Control-Allow-Origin": "*",
      },
    }
  )
    .then((res) => res.json())
    .then(
      (data) => {
        return data;
      },
      (error) => console.log("error", error)
    );
  return await result;
}

export function compiledFlowHC(currentProductPredictorScenario, currentProductPredictorScenarioGroups, grp_name) {
  let currentProductPredictorGroupConfigurationGroup = currentProductPredictorScenarioGroups.filter(x => x.name === grp_name)[0]
  if (currentProductPredictorScenario.status === SCENARIO_STATUS.COMPUTED) {
    const group_recycle = currentProductPredictorScenario.output.products.filter(x => currentProductPredictorGroupConfigurationGroup.recyclelabels?.includes(x.name)).reduce((pre, curr) => Number(pre) + Number(curr.value), 0);
    return ((Number(currentProductPredictorGroupConfigurationGroup.feedstock!.reduce((prev, feed) => prev + (Number(feed.flowrate) > 0 ? Number((feed.flowrate)) : 0), 0)) + group_recycle) / Number(currentProductPredictorGroupConfigurationGroup.furnace_number)).toFixed(1)
  }
  else {
    return (Number(currentProductPredictorGroupConfigurationGroup.feedstock!.reduce((prev, feed) => prev + (Number(feed.flowrate) > 0 ? Number((feed.flowrate * getFactor(feed.name))) : 0), 0)) / Number(currentProductPredictorGroupConfigurationGroup.furnace_number)).toFixed(1)
  }
}

export function isTMTCameraDeviation() {
  return store.getState().features.accessibleFeatures.includes("HOME_TMT_CAMERA_STATUS_INFO");
}

export function convertWTToMolFrac(volfraction, mw): string[] {
  const nominator: number[] = new Array(volfraction.length).fill(0);
  let denominator = 0.0;
  let rsum = 0.0;

  for (let i = 0; i < volfraction.length; i++) {
      nominator[i] = Number(volfraction[i]) / Number(mw[i]);
      denominator += nominator[i];
      rsum += Number(volfraction[i]);
  }

  const ret: string[] = new Array(volfraction.length).fill(0);
  for (let i = 0; i < volfraction.length; i++) {
      ret[i] = (nominator[i] * 100.0 / denominator).toFixed(3).toString();
  }

  return ret;
}

export const getEventDetails = ( ruleId, furnace_name,coilgroup_name_max,coilgroup_name_min,camera_id,camera_temperature, coilgroup_name, camera_id_min, camera_id_max, sliceData? ) => {
  if(ruleId === 1){
    return `Furnace ${furnace_name} exceeds the max TMT limit`
  }else if(ruleId === 2){
    return `High deviations in max TMT between coils in Furnace ${furnace_name} for coilgroup ${coilgroup_name}`
  }else if(ruleId === 3){
  if(coilgroup_name_max === coilgroup_name_min) {
      return `High deviations in max TMT in coilgroup ${coilgroup_name_max} for camera ${camera_id_min} and camera ${camera_id_max}`
  }
    return `High deviations in max TMT between coilgroup ${coilgroup_name_max} and ${coilgroup_name_min}`
  }else if(ruleId === 4){
    return `No images from camera ${camera_id} received for last 30 minutes`
  }else if(ruleId === 5){
    return `Camera ${camera_id} is not connected`
  }else if(ruleId === 6){
    return `Camera temperature for camera ${camera_id} is ${camera_temperature}, which is exceeding notification level`
  }else if(ruleId === 10){
    return `High deviations between neighboring Slices ${sliceData?.sliceName} and ${sliceData?.neighbourSliceName}`
  }
}

const getPlantTimezone = () => {
  let plants = JSON.parse(JSON.stringify(getPlantReferences()));
  const currentPlantId = store.getState().scenarioSimulator.currentPlantId
  let currentPlant = plants.filter(item => item.id === currentPlantId)
  currentPlant = currentPlant[0]
  return currentPlant?.timezone;
}

//this method converts date time based on config, default is plant wise and if not set from config then local time zone.
export const convertDateTimeBasedOnConfig = (
  dateStr: string | number | undefined,
  type?: 'dateOnly' | 'timeOnly'
) => {
  if (dateStr === undefined) {
    return '';
  }
  const updatedDate = new Date(dateStr);
  const current_plant_timezone = getPlantTimezone() ? getPlantTimezone() : undefined;
  const locale = window?.navigator?.language;
  if (isNaN(updatedDate.getTime())) {
    return '';
  }
  
  if (type === 'dateOnly') {
    return updatedDate.toLocaleDateString(locale, {
      timeZone: current_plant_timezone,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    });
  }

  if (type === 'timeOnly') {
    return updatedDate.toLocaleTimeString(locale, {
      timeZone: current_plant_timezone,
      hour12: false,
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  return updatedDate.toLocaleString(locale, {
    timeZone: current_plant_timezone,
    hour12: false,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
 
};

// Returns a Date object whose local wall-clock matches the plant timezone wall-clock.
// Useful for date/time pickers that need a Date (not a formatted string) but should
// still display the plant-configured timezone.
export const convertDateToPlantTimezoneDate = (
  dateStr: string | number | Date | undefined
): Date | null => {
  if (dateStr === undefined || dateStr === null) {
    return null;
  }
  const updatedDate = new Date(dateStr);
  if (isNaN(updatedDate.getTime())) {
    return null;
  }
  const current_plant_timezone = getPlantTimezone() ? getPlantTimezone() : undefined;
  if (!current_plant_timezone) {
    return updatedDate;
  }
  // en-US locale produces a string that `new Date()` can reliably parse.
  const zonedString = updatedDate.toLocaleString('en-US', { timeZone: current_plant_timezone });
  const zonedDate = new Date(zonedString);
  return isNaN(zonedDate.getTime()) ? updatedDate : zonedDate;
};

// Inverse of `convertDateToPlantTimezoneDate`.
// Takes a Date coming from a picker whose local wall-clock fields represent the
// plant timezone wall-clock (e.g. the user typed "28 July 18:30" meaning plant time),
// and returns the real UTC instant for that plant wall-clock. This prevents the value
// from being converted into the plant timezone a second time on the next render.
export const convertPlantTimezoneDateToUtcDate = (
  dateStr: string | number | Date | undefined 
): Date | null => {
  if (dateStr === undefined || dateStr === null) {
    return null;
  }
  const pickedDate = new Date(dateStr);
  if (isNaN(pickedDate.getTime())) {
    return null;
  }
  const current_plant_timezone = getPlantTimezone() ? getPlantTimezone() : undefined;
  if (!current_plant_timezone) {
    return pickedDate;
  }
  // The picked date's local fields represent the plant wall-clock the user selected.
  const utcGuess = Date.UTC(
    pickedDate.getFullYear(),
    pickedDate.getMonth(),
    pickedDate.getDate(),
    pickedDate.getHours(),
    pickedDate.getMinutes(),
    pickedDate.getSeconds()
  );
  const tzView = new Date(new Date(utcGuess).toLocaleString('en-US', { timeZone: current_plant_timezone }));
  const utcView = new Date(new Date(utcGuess).toLocaleString('en-US', { timeZone: 'UTC' }));
  const offset = tzView.getTime() - utcView.getTime();
  const realInstant = new Date(utcGuess - offset);
  return isNaN(realInstant.getTime()) ? pickedDate : realInstant;
};

// export const convertDateOrTimeToLocale = (
//   dateTimeStr: Date | undefined,
//   type: 'dateOnly' | 'timeOnly'
// ): string  => {
//   if(type === 'timeOnly') {
//     const localeTimeString = new Date(dateTimeStr ?? '').toLocaleTimeString(undefined, {hour12:false, hour: '2-digit', minute: '2-digit'})
//     return localeTimeString;
//   }

//   if(type === 'dateOnly') {
//     const localeDateString = new Date(dateTimeStr ?? '').toLocaleDateString(undefined, {hour12: false})
//     return localeDateString
//   }

//   return  '';
// }

//this method converts date time based on config, default is plant wise and if not set from config then local time zone.
export const convertDateTimeBasedOnConfigPostgre = (dateStr: string | number) => {
  const updatedDate = new Date(dateStr);
  const current_plant_timezone = getPlantTimezone() ? getPlantTimezone() : undefined
  if (isNaN(updatedDate.getTime())) {
    return '';
  }
  return new Date(Date.parse(updatedDate.toString()) - updatedDate.getTimezoneOffset() * 60000).toLocaleString(undefined, { 
    timeZone: current_plant_timezone,
    hour12: false,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
} 

export const isThermalImageCoilSlice = () => {
  return store.getState().features.accessibleFeatures?.includes("THERMAL_IMAGE_COIL_SLICE")
}

export const getNotificationHeader = () => {

  let headers = ["Event Type","Name Of Event","Date/Timestamp","Furnace","Camera","Operating Mode","Equipment Level","Severity","Category","Event Text"]
  // if(isThermalImageCoilSlice()){
  //   headers = [...headers ,"Slice Name","Slice Value","Neighbor Slice Name","Neighbor Slice Value"];
  // }

  return headers;
}

export const ParseTemperatureValue = (number) => {
  try{
    if(!isNaN(number))
      return Math.round(number)
    else
      return number
  }
  catch{
    return "N/A"
  }
}

export async function getIsEditableCheckForRole(plantId, roleId, accessToken) {

  const isEditableData = fetch(`${REACT_APP_APIM_URL}/thermalimage/getIsEditableForRole/${plantId}/${roleId}`, {
    method: "GET",
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
      "Access-Control-Allow-Origin": "*"
    },
  })
  .then((res) => res.json())
  .then(
    (isEditableData) => {
      return isEditableData;
    }
  )
  return await isEditableData;
}

export const localeDateTimeFormat = (locale?: string): string => {
  const formats: Record<string, string> = {
    en: 'MM/dd/yyyy, HH:mm',
    de: 'dd.MM.yyyy, HH:mm',
    fr: 'dd/MM/yyyy HH:mm',
    es: 'dd/MM/yyyy HH:mm',
    it: 'dd/MM/yyyy HH:mm',
    nl: 'dd-MM-yyyy HH:mm',
  };

  if (!locale) {
    return formats.en;
  }

  const exactFormats: Record<string, string> = {
    'en-US': 'MM/dd/yyyy, HH:mm',
    'en-GB': 'dd/MM/yyyy, HH:mm',
    'de-DE': 'dd.MM.yyyy, HH:mm',
    'de-AT': 'dd.MM.yyyy, HH:mm',
    'de-CH': 'dd.MM.yyyy, HH:mm',
    'fr-FR': 'dd/MM/yyyy HH:mm',
  };

  if (exactFormats[locale]) {
    return exactFormats[locale];
  }

  const language = locale.split('-')[0].toLowerCase();
  
  return formats[language] || formats.en;
};

export const extractCoilNumber = (coilName: string, isOldConvention = false): number |  string => {
    if (!isOldConvention) {
      const parts = coilName.split('_');
      const coilNumber = parts[2].split('-');
      return coilNumber[0];
    } else {
      return parseInt(coilName.slice((coilName.lastIndexOf("-") + 1)).replace(/[^0-9]+/gi, ""));
    }
  }

export const  extractCoilNameFromSlice = (sliceName: string) => {
    let tempArr = sliceName.split('_').slice(0, 3)
    let coilNumber = tempArr[tempArr.length - 1].split('-')[0];
    tempArr.pop();
    tempArr.push(`OUT-${coilNumber}`);
    return tempArr.join('_');
}

export const isCoilNumberIncludesInOut = (coilName: string) : boolean => {
 return coilName.includes("OUT") || coilName.includes("IN");
}

export const removeCoilNumberFromCoilName = (coilName: string) : string => {
if(!!coilName.length) {
  const lastHyphenIndex = coilName.lastIndexOf('-');
  const result = coilName.slice(0, lastHyphenIndex);
  return result;
}
return '';
}


// reduce 2k image to  480 with dynamic image height
export const reduce2kImageSize = (dataArray:any[], item:any[], imageHeight:any) => {
  let conversionlimit = imageHeight/480;
  let val1 = dataArray.length > 480 ? item[0]/conversionlimit:item[0];
  let val2 = dataArray.length > 480 ? item[1]/conversionlimit:item[1];
  return { val1, val2 }
}


// reduce 2k image dots to 640 x 480 with dynamic image height
export const reduce2kImageDotSize = (dataArray:any[], item:any[], imageHeight:any, imageWidth: any, divisor:{height:any, width:any}) => {
  let heightConversionLimit = imageHeight/divisor.height;
  let widthConversionLimit = imageWidth/divisor.width;
  let maxY = dataArray.length > divisor.height ? item[1]/heightConversionLimit:item[1];
  let maxX = dataArray.length > divisor.width ? item[0]/widthConversionLimit:item[0];
  return { maxX, maxY }
}

export const debounce = (mainFunction: any, delay: number) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      mainFunction(...args);
    }, delay);
  };
};

export function isClearWebAppCacheVisible() {
  return store.getState().features.accessibleFeatures.includes("CLEAR_CACHE");
}


//created below function to enhance x and y coordinates as per 2k image  
export function setCoordinatesFor2K (x : number, y : number, imageHeight: number, imageWidth : number) {
 const convertedXCoordinate = ((x - 30) * imageWidth) / 640;
 const convertedYCoordinate = y * imageHeight / 480;
 return {convertedXCoordinate, convertedYCoordinate}  
}

export const isImageCompressed = (imageString: string) => {
  if(imageString.includes('-zst')) {
    return "True";
  }
  return "False";
}